import { render } from "./PropertyCard.vue?vue&type=template&id=ffc39ac4&scoped=true&ts=true"
import script from "./PropertyCard.vue?vue&type=script&lang=ts"
export * from "./PropertyCard.vue?vue&type=script&lang=ts"

import "./PropertyCard.vue?vue&type=style&index=0&id=ffc39ac4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffc39ac4"]])

export default __exports__